/**
 * Utilidades específicas para extracción de datos
 * Funciones que no son de configuración sino de lógica de negocio
 */

// Exportar datos en diferentes formatos
export const exportData = async (data, fileName, format, selectedDocumentFields = []) => {
  const dataToExport = data.map(result => {
    const row = {
      'Archivo': result.fileName
    };
    
    // Usar extractedData (que ya está normalizado en onDownloadHistory)
    const extractedData = result.extractedData || {};
    
    // Agregar los campos especificados
    selectedDocumentFields.forEach(field => {
      const fieldName = field.nombre || field;
      row[fieldName] = extractedData[fieldName] || '-';
    });
    
    return row;
  });

  switch (format) {
    case 'excel':
      try {
        // Importar el servicio aquí para evitar dependencias circulares
        const { extractionAPI } = await import('../services/extractionAPI');
        
        const response = await extractionAPI.exportToExcel(data, selectedDocumentFields);
        
        if (response.success) {
          // Crear blob y descargar
          const url = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = url;
          // Usar el filename que viene del backend en lugar del que se pasa como parámetro
          link.download = response.filename || `${fileName}.xlsx`;
          link.click();
          URL.revokeObjectURL(url);
          
          return { success: true, fileName: response.filename || `${fileName}.xlsx` };
        } else {
          return { success: false, error: response.error };
        }
      } catch (error) {
        return { success: false, error: 'Error al generar archivo Excel' };
      }
    
    case 'csv':
      try {
        // Convertir a CSV
        const csvHeaders = Object.keys(dataToExport[0]).join(',');
        const csvRows = dataToExport.map(row => 
          Object.values(row).map(value => `"${String(value).replace(/"/g, '""')}"`).join(',')
        );
        const csvContent = [csvHeaders, ...csvRows].join('\n');
        
        // Crear blob y descargar
        const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const csvUrl = URL.createObjectURL(csvBlob);
        const csvLink = document.createElement('a');
        csvLink.href = csvUrl;
        csvLink.download = `${fileName}.csv`;
        csvLink.click();
        URL.revokeObjectURL(csvUrl);
        return { success: true, fileName: `${fileName}.csv` };
      } catch (error) {
        return { success: false, error: 'Error al generar archivo CSV' };
      }
    
    case 'json':
      try {
        // Convertir a JSON
        const jsonContent = JSON.stringify(dataToExport, null, 2);
        const jsonBlob = new Blob([jsonContent], { type: 'application/json' });
        const jsonUrl = URL.createObjectURL(jsonBlob);
        const jsonLink = document.createElement('a');
        jsonLink.href = jsonUrl;
        jsonLink.download = `${fileName}.json`;
        jsonLink.click();
        URL.revokeObjectURL(jsonUrl);
        return { success: true, fileName: `${fileName}.json` };
      } catch (error) {
        return { success: false, error: 'Error al generar archivo JSON' };
      }
    
    default:
      return { success: false, error: 'Formato no válido' };
  }
};
